import React, { ChangeEvent, useState } from "react";
import { Installation, Device, Organization } from "../common/ObjectTypes";
import { AddIcon, DeleteIcon } from "../common/ProjectIcons";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import Pagination from "../common/Pagination";
import { Link } from "react-router-dom";
import { getCurrentUser } from "../../helpers/authHeader";
import DeviceLookupModal from "./DeviceLookupModal";
import tailwindClassnames from "../common/TaildwindClassnames";

type DeviceListTypes = {
  devices: Device[];
  installations: Installation[];
  organizations: Organization[];
  onSelectDevice: Function;
  onClickAdd: Function;
  onDelete: Function;
  pageCount: number;
  pageSize: number;
  totalCount: number;
  handlePageClick: (selectedItem: { selected: number }) => void;
  reloadPage: boolean;
  recordStart: number;
  recordEnd: number;
  onSearch: Function;
  onChangeSearch: Function;
  lookupError: string;
  onDeviceLookup: Function;
  searchQuery: any;
  loading: boolean;
  onOpenDeviceLookupModal: Function;
  onCloseDeviceLookupModal: Function;
  isModalOpen: boolean;
  onChangeLookup: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  wildXRNumber: string;
};

const DeviceList = ({
  devices,
  installations,
  organizations,
  onSelectDevice,
  onClickAdd,
  pageCount,
  pageSize,
  totalCount,
  handlePageClick,
  reloadPage,
  recordStart,
  recordEnd,
  searchQuery,
  onSearch,
  onChangeSearch,
  onOpenDeviceLookupModal,
  onCloseDeviceLookupModal,
  isModalOpen,
  onChangeLookup,
  wildXRNumber,
  lookupError,
  onDeviceLookup,
  // subStr,
  loading,
}: DeviceListTypes) => {
  const currentUser = getCurrentUser();
  const getInstallationNameById = (id: any) => {
    if (!id) return null;
    let installationName = installations?.find(
      (install) => install.installationId.toLocaleLowerCase() === id
    );
    return installationName?.name || null;
  };

  const getOrganizationNameById = (id: any) => {
    if (!id) return null;

    let organizationName = organizations?.find(
      (org) =>
        org.organizationId &&
        org.organizationId.toLocaleLowerCase() === id.toLocaleLowerCase()
    );
    return organizationName?.name || null;
  };
  return (
    <div className="p-6">
      {/* List */}
      <div className="flex flex-row justify-between">
        <h1 className={tailwindClassnames.tableTitle}>Devices</h1>
      </div>{" "}
      <div className="flex flex-row items-center mt-4">
        <div className="flex flex-row mr-auto w-1/3">
          <TextInput
            name=""
            label=""
            onChange={onChangeSearch}
            value={searchQuery.name}
            placeholder="Filter by name"
            error={null}
            initialFocus={false}
            className={tailwindClassnames.searchTextInput}
            disabled={false}
            type=""
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                onSearch();
              }
            }}
          />
          <button
            onClick={() => onSearch()}
            className={tailwindClassnames.searchButton}
          >
            Search
          </button>
        </div>
        <div>
          <div className="flex justify-end">
            <button
              onClick={() => onOpenDeviceLookupModal()}
              className={tailwindClassnames.lookupButton}
            >
              Device Lookup
            </button>
            <DeviceLookupModal
              onChange={onChangeLookup}
              isOpen={isModalOpen}
              onClose={onCloseDeviceLookupModal}
              wildXRNumber={wildXRNumber}
              devices={devices}
              onDeviceLookup={onDeviceLookup}
              lookupError={lookupError}
            />
          </div>
        </div>
      </div>
      <table className={tailwindClassnames.tableContainer}>
        <thead className={tailwindClassnames.tableHead}>
          <tr>
            <th className={tailwindClassnames.tableHeadText}>Name</th>
            <th className={tailwindClassnames.tableHeadText}>WildXR Number </th>
            <th className={tailwindClassnames.tableHeadText}>Installation</th>
            <th className={tailwindClassnames.tableHeadText}>Organization</th>
          </tr>
        </thead>
        <tbody>
          {devices
            .filter((device) => device.organizationId) // Filter out devices without organizationId
            .map((device: Device, index: number) => {
              const rowClass =
                index % 2 === 0 ? "bg-grayScale-200" : "bg-grayScale-100";
              return (
                <tr
                  key={device.deviceId}
                  className={rowClass + tailwindClassnames.tableBody}
                  onClick={() => onSelectDevice(device.deviceId)}
                >
                  <td className={tailwindClassnames.tableBodyText}>
                    {device.name}
                  </td>
                  <td className={tailwindClassnames.tableBodyText}>
                    {device.wildXRNumber}
                  </td>
                  <td className={tailwindClassnames.tableBodyText}>
                    {getInstallationNameById(device.installationId)}
                  </td>
                  <td className={tailwindClassnames.tableBodyText}>
                    {getOrganizationNameById(device.organizationId)}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>{" "}
      <Pagination
        handlePageClick={handlePageClick}
        pageCount={pageCount}
        recordStart={recordStart}
        recordEnd={recordEnd}
        totalCount={totalCount}
        loading={loading}
        pageSize={searchQuery.pageSize}
        selectPage={false}
        searchQuery={searchQuery}
      />{" "}
    </div>
  );
};

export default DeviceList;
